<template>
  <div id="app">
    <b-container fluid id="page-container">
      <Navbar :key="$route.fullPath" />
      <b-row id="content-wrap">
        <b-col>
          <!-- Navbar -->
          <!-- Dynamic content dependant on page -->
          <router-view :key="$route.fullPath" />
        </b-col>
      </b-row>
      <!-- Footer -->
      <Footer />
    </b-container>
  </div>
</template>

<script>
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

export default {
  components: {
    Footer,
    Navbar,
  },
};
</script>

<style lang="scss">
img {
  max-width: 100%;
}
* {
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 0.03em;
}
body {
  background-color: white;
}

#nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 33;
  background: #20b3d7;
  width: 100vw;
}
#banner {
  background: green;
}
#page-container {
  position: relative;
  min-height: 100vh;
}

#content-wrap {
  min-height: 66vh;
  margin-top: 150px;
  padding: 30px;
}

@media screen and (max-width: 768px) {
  #nav-bar {
    width: unset;
  }
  #content-wrap {
    padding: 0;
  }
  .dropdown-menu {
    background: transparent;
    color: white;
    text-align: center;
    grid-template-columns: 1fr 1fr;
  }
  .dropdown-item {
    color: white;
  }
}
a.nav-link {
  color: white !important;
}

ul.dropdown-menu {
  border: none;
}

.center-title {
  font-weight: 600;
  font-size: 2rem;
}

/* the slides */

/* the parent */
.slick-list {
  margin: 0 -15px;
}

.slick-prev:before,
.slick-next:before {
  color: black !important;
}

.recommendation-card-title {
  color: #333333;
}

.recommendation-card-price {
  font-size: larger;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #333333;
  background-color: #333333;
}
.modal-content {
  border-radius: 0.9rem;
}
.modal-backdrop {
  background-color: none;
  background-image: url(/images/background_gradient.png);
  background-size: contain;
}
.modal-header {
  position: relative;
}

h5 .modal-title {
  font: small !important;
}
.btn {
  border-radius: 10px;
}
.btn-primary {
  background-color: #41b2d2;
  border-color: #41b2d2;
}
.btn-outline-primary {
  border-color: #41b2d2;
  color: #41b2d2;
}
.badge-primary {
  background-color: #41b2d2;
  color: white;
}
.badge-primary.active {
  background-color: #2b86a0;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #399ab5 !important;
  border-color: #399ab5 !important;
}
.dropdown-menu.show {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
